<script>
import WyborLeku from "@/components/clients/WyborLeku.vue";
import swal from "sweetalert";
import {receptyService, roleService} from "@/services";
import HasloCertyfikatu from "@/components/clients/HasloCertyfikatu.vue";
import {mapState} from "vuex";

export default {
  name: "NowaRecepta",
  components: {HasloCertyfikatu, WyborLeku},
  props: ["clientid","therapistid","visitid","pakiet"],
  data() {
    return {
      isValid: true,
      wybrana_recepta: null,
      rodzaje_recept: ['Rp','Rpw'],
      poziomy_odplatnosci: [{text: '100%', value: '100%'}, {text: '50%', value: '50%'},{text: '30%', value: '30%'},{text: 'ryczałt', value: 'R'},{text: 'bezpłatne', value: 'B'}],
      recepty: [
        {
          id: 0,
          poziom_odplatnosci: '100%',
          rodzaj_recepty: 'Rp',
          wybrany_lek: null,
          ilosc_sztuk:0,
          dawkowanie: ''
        }
      ],
      lista_lekow: [],
      showGetPassword: false,
      certPassword: null,
      lista_lekow_szukanie: false,
      wybrany_lek: null,
      lekKeyword: ''
    }
  },
  methods: {
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

          }
      )
    },
    lekWybrany(lek,recepta)
    {
      if(lek == null)
      {
        return
      }
      recepta.wybrany_lek = {lek_id: lek.lek.id, opakowanie_id: lek.opakowanie.id}
    },
    removeRecepta(index)
    {
      this.recepty.splice(index,1)
    },
    anulujRecepte(recepta)
    {
      if(this.wymagane_haslo_certyfikatu && !this.certPassword)
      {
        this.showGetPassword = true
        return
      }
      swal({
        title: "Czy na pewno?",
        text:
            "Czy na pewno chcesz anulować tę recepte?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          receptyService.anulujRecepte(recepta.id,this.pakiet.id,this.certPassword).then(() => {
            recepta.status = 1
          }).catch((error) => {
            let err = error.response
            if (err.data != null && err.data.error && err.data.error.message) {
              this.showError(err.data.error.message)
            } else {
              this.showError("Nie można anulować recepty")
            }
          })
        }
      });


    },
    closeGetPasword() {
      this.showGetPassword = false
    },
    saveGetPassword(pass) {
      this.showGetPassword = false
      this.certPassword = pass
    },
    zapiszRecepty()
    {
      if(this.$refs.form.validate())
      {
          if(this.pakiet != null)
          {
            let validLeki = false
            for (let i = 0; i < this.recepty.length; i++) {
              if (this.recepty[i].wybrany_lek == null && this.recepty[i].id == 0)
              {
                validLeki = false
                break
              } else {
                validLeki = true
              }
            }
            if (!validLeki) {
              this.showError('Nie wybrano wszystkich leków')
              return
            }
            receptyService.updatePakietRecept({
              id: this.pakiet.id,
              recepty: this.recepty
            }).then(() => {
              this.$emit('close')
            }).catch((error) => {
              let err = error.response
              if (err.data != null && err.data.error && err.data.error.message) {
                this.showError(err.data.error.message)
              } else {
                this.showError("Nie zapisać recepty")
              }
            })
          }
          else
          {
            let validLeki = false
            for (let i = 0; i < this.recepty.length; i++) {
              if (this.recepty[i].wybrany_lek == null) {
                validLeki = false
                break
              } else {
                validLeki = true
              }
            }
            if (!validLeki) {
              this.showError('Nie wybrano wszystkich leków')
              return
            }

            //pora na zapis
            receptyService.createPakietRecept({
              client_id: this.clientid,
              therapist_id: this.therapistid,
              visit_id: this.visitid,
              recepty: this.recepty
            }).then(() => {
              this.$emit('close')
            }).catch((error) => {
              let err = error.response
              if (err.data != null && err.data.error && err.data.error.message) {
                this.showError(err.data.error.message)
              } else {
                this.showError("Nie zapisać recepty")
              }
            })
          }
        }
    }
  },
  computed: {
    ...mapState('account', ['userdetails']),
    wymagane_haslo_certyfikatu: function() {
      return this.userdetails != null && this.userdetails.therapistDetails != null && this.userdetails.therapistDetails.czyWymagaHaslaCertyfikatu;
    },
    requiredRule() {
      return value => !!value || 'Ilość opakowań jest wymagana'
    },
    requiredRuleDawakowanie() {
      return value => !!value || 'Dawkowanie jest wymagane'
    },
    numericRule() {
      return value => /^\d+$/.test(value) || 'Ilośc opakowań musi być liczbą całkowitą'
    },
    mozliwa_edycja() {
      return this.pakiet == null || this.pakiet.status == 0
    },
    mozliwe_anulowanie() {
      return this.pakiet != null && this.pakiet.status == 1
    }
  },
  watch: {
    pakiet: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if(newVal != null)
        {
          this.recepty = []
          newVal.recepty.forEach(elem => {
            this.recepty.push({
              id: elem.id,
              poziom_odplatnosci: elem.poziom_odplatnosci,
              rodzaj_recepty: elem.rodzaj_recepty,
              nazwa_leku: elem.nazwa_leku,
              opakowanie_leku: elem.opakowanie_leku,
              ilosc_sztuk: elem.ilosc_sztuk,
              dawkowanie: elem.dawkowanie,
              status: elem.status,
              numer_w_pakiecie: elem.numer_w_pakiecie
            })
          })
        }
      }
    },
  }
}

</script>

<template>
  <v-container>

    <v-row>
      <v-col>
        <v-form     ref="form"
                    v-model="isValid"
                    lazy-validation>
        <v-card v-for="(recepta,index) in recepty" v-bind:key="index" class="ma-4">
          <v-card-title>
            Lek {{recepta.id == 0 ? index+1 : recepta.numer_w_pakiecie}}
            <v-spacer></v-spacer>
            <v-btn v-if="mozliwa_edycja" icon @click.native="removeRecepta(index, recepta)"><v-icon>fa-times</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="6">
                  <v-select label="Rodzaj recepty" :items="rodzaje_recept" v-model="recepta.rodzaj_recepty" :readonly="recepta.id > 0"></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select label="Odpłatność" :items="poziomy_odplatnosci" v-model="recepta.poziom_odplatnosci" :readonly="recepta.id > 0"></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <WyborLeku @wybranoLek="(lek) => {lekWybrany(lek,recepta)}" v-if="recepta.id == 0"></WyborLeku>
              <v-row v-if="recepta.id > 0">
                <v-col cols="12" sm="12" md="6" lg="6">
                  <v-text-field label="Nazwa leku" v-model="recepta.nazwa_leku" readonly></v-text-field>

                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <v-text-field label="Opakowanie" v-model="recepta.opakowanie_leku" readonly></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="6">
                  <v-text-field label="Dawkowanie" placeholder="Wprowadź dawkowanie" v-model="recepta.dawkowanie" :rules="[requiredRuleDawakowanie]" :readonly="recepta.id > 0"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6">
                  <v-text-field label="Ilośc opakowań"  min="1" v-model.number="recepta.ilosc_sztuk" step="1"  type="number" :rules="[requiredRule,numericRule]" :readonly="recepta.id > 0">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <span style="color:red" v-if="pakiet != null && pakiet.status == 1 && recepta.id > 0 && recepta.status == 1">Recepta anulowana</span>
            <v-btn color="error" v-if="pakiet != null && pakiet.status == 1 && recepta.id >0 && recepta.status == 0" @click="anulujRecepte(recepta)">Anuluj recepte</v-btn>
          </v-card-actions>
        </v-card>
        </v-form>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-btn color="primary" v-if="mozliwa_edycja" title="Dodaj recepte" fab elevation="10" class="mr-11"  x-large rounded @click="recepty.push({id: 0,poziom_odplatnosci: '100%', rodzaj_recepty: 'Rp', lek: null, ilosc_sztuk:0, dawkowanie: '', status: 0})" :disabled="recepty != null && recepty.length == 5">
        <v-icon>fa-plus</v-icon>
      </v-btn>
        <v-btn color="success" v-if="mozliwa_edycja" title="Zapisz pakiet recept" fab elevation="10"  x-large rounded @click="zapiszRecepty">
          <v-icon>fa-save</v-icon>
        </v-btn>

    </v-row>
    <HasloCertyfikatu v-if="showGetPassword" :visible="showGetPassword" @close="closeGetPasword" @save="saveGetPassword"></HasloCertyfikatu>
  </v-container>
</template>

<style scoped>

</style>